import { render } from "./Octocoins.vue?vue&type=template&id=e33d4f46&scoped=true"
import script from "./Octocoins.vue?vue&type=script&lang=js"
export * from "./Octocoins.vue?vue&type=script&lang=js"

import "./Octocoins.vue?vue&type=style&index=0&id=e33d4f46&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e33d4f46"]])

export default __exports__